import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { mergeClasses } from '@frontend/design-system';
import { CALENDAR_Z_INDICES } from '../../constants';

export const EventDragHandle = ({ listeners, className }: { listeners?: SyntheticListenerMap; className?: string }) => {
  return (
    <div
      className={mergeClasses('calendar-grid-event-drag-handle', className)}
      css={eventDragHandleStyle}
      {...listeners}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <Icon name='dragand-drop-handle' color='default' size={16} css={dragIconStyle} />
    </div>
  );
};

const eventDragHandleStyle = css({
  display: 'none',
  position: 'absolute',
  top: '50%',
  left: 2,
  transform: 'translate(calc(-100% + 4px), -50%)',
  padding: 2,
  zIndex: CALENDAR_Z_INDICES.eventDragHandle,
  cursor: 'grab',
  // Required for @dnd-kit touch support
  touchAction: 'none',
  opacity: 1,
});

const dragIconStyle = css({
  background: theme.colors.white,
  boxShadow: theme.shadows.light,
  borderRadius: '2px',
});

export const eventDragHandleContainerStyle = (isDragOverlay = false, isDragging = false) =>
  css([
    {
      '.calendar-grid-event-drag-handle': { height: 'auto' },
      [`${(isDragOverlay && '&') || (!isDragging && '&:hover') || 'none'} > .calendar-grid-event-drag-handle`]: {
        display: 'flex',
      },
    },
    isDragOverlay && {
      '.calendar-grid-event-drag-handle': {
        transform: 'translate(calc(-100% + -10px), calc(-50% + 15px)) rotate(-10deg)',
        width: 'auto',
      },
    },
  ]);
